import React from 'react';

import './style.scss';

const Limitations = () => (
  <div className='text-center freight-restrictions'>
    <h3>Time Limit and Forum for Law Suits:</h3>
    <p>
      <i className='far fa-exclamation-circle' /> In cases governed by 46 United
      States Code Section 30508, no civil action against the Company, its
      personnel or its vessels may be brought more than one year after the
      occurrence if based on personal injury or death, or six months after
      passage if based on other claims (including property loss/damage), and
      such law suits must be brought in either the U.S. District Court for the
      Eastern District of New York (Central Islip) or state court in Suffolk
      County, NY. The aggregate liability for property loss/damage is limited to
      $200.00 per occurrence.
    </p>
  </div>
);

export default Limitations;
